type Props = {
    level: number;
    children: React.ReactNode;
  };
  
export const MarkdownHeading = ({ level, children }: Props) => {
    const heading = children?.toString();
    let anchor = typeof heading === 'string' ? heading.toLowerCase() : '';
    anchor = anchor.replace(/[^a-zA-Z0-9 ]/g, '');
    anchor = anchor.replace(/ /g, '-');
  
    const container = (children: React.ReactNode): JSX.Element => (
      <a id={anchor} href={`#${anchor}`}>
        <span>{children}</span>
      </a>
    );
  
    switch (level) {
      case 1:
        return <h1>{container(children)}</h1>;
      case 2:
        return <h2>{container(children)}</h2>;
      case 3:
        return <h3>{container(children)}</h3>;
      default:
        return <h6>{container(children)}</h6>;
    }
  };
  